module.exports = __webpack_public_path__ + "img/teacher_management.1f68dae5.png";